function mtInitAll() {
  initReveal();
  initProducto();
  initColeccionCarrito();
  initFaq();
  initHeroCarrusel();
}

document.addEventListener('DOMContentLoaded', mtInitAll);

/* El editor de temas de Shopify reemplaza el HTML de una sección entera cada
   vez que cambias un ajuste, y no dispara DOMContentLoaded otra vez: hay que
   re-enganchar los comportamientos (animaciones, carrito, FAQ, carrusel...)
   a mano cuando eso pasa, o el contenido nuevo se queda "roto" a ojos del
   usuario (invisible o sin interacción) hasta recargar la página. */
document.addEventListener('shopify:section:load', mtInitAll);
document.addEventListener('shopify:block:select', mtInitAll);

function initFaq() {
  var listas = document.querySelectorAll('[data-mt-faq]');
  listas.forEach(function (lista) {
    lista.querySelectorAll('[data-mt-faq-toggle]').forEach(function (btn) {
      if (btn.hasAttribute('data-mt-bound')) return;
      btn.setAttribute('data-mt-bound', 'true');
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq-item');
        var respuesta = item.querySelector('.mt-faq-respuesta');
        var abierto = item.classList.contains('mt-abierto');
        lista.querySelectorAll('.mt-faq-item.mt-abierto').forEach(function (otro) {
          otro.classList.remove('mt-abierto');
          otro.querySelector('.mt-faq-respuesta').style.maxHeight = null;
        });
        if (!abierto) {
          item.classList.add('mt-abierto');
          respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        }
      });
    });
  });
}

function initHeroCarrusel() {
  var carruseles = document.querySelectorAll('[data-mt-hero-carrusel]');
  carruseles.forEach(function (carrusel) {
    if (carrusel.hasAttribute('data-mt-bound')) return;
    carrusel.setAttribute('data-mt-bound', 'true');
    var slides = carrusel.querySelectorAll('[data-mt-hero-slide]');
    if (slides.length < 2) return;
    var dots = carrusel.querySelectorAll('[data-mt-hero-dot]');
    var prev = carrusel.querySelector('[data-mt-hero-prev]');
    var next = carrusel.querySelector('[data-mt-hero-next]');
    var actual = 0;
    var timer;

    function mostrar(i) {
      slides[actual].classList.remove('mt-activa');
      if (dots[actual]) dots[actual].classList.remove('mt-activa');
      actual = (i + slides.length) % slides.length;
      slides[actual].classList.add('mt-activa');
      if (dots[actual]) dots[actual].classList.add('mt-activa');
    }

    function auto() {
      clearInterval(timer);
      timer = setInterval(function () { mostrar(actual + 1); }, 5500);
    }

    if (next) next.addEventListener('click', function () { mostrar(actual + 1); auto(); });
    if (prev) prev.addEventListener('click', function () { mostrar(actual - 1); auto(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { mostrar(i); auto(); });
    });
    auto();
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal:not(.mt-visible), .mt-reveal-scale:not(.mt-visible)');
  if (!els.length) return;

  var enEditor = window.Shopify && Shopify.designMode;
  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (enEditor || sinMovimiento) {
    /* Dentro del editor de temas mostramos todo de inmediato: el merchant
       necesita ver y editar el contenido sin esperar a hacer scroll, y las
       secciones que el editor reemplaza no vuelven a cruzar el viewport. */
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = el.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { el.classList.add('mt-visible'); }, Number(delay));
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function (el, i) {
    if (!el.hasAttribute('data-mt-delay')) {
      el.setAttribute('data-mt-delay', String((i % 4) * 90));
    }
    observer.observe(el);
  });
}

function mtFormatMoney(cents, format) {
  var value = (cents / 100).toFixed(2);
  var parts = value.split('.');
  var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ',' + parts[1];
  if (!format) return '$' + parts[0] + '.' + parts[1];
  return format
    .replace(/\{\{\s*amount\s*\}\}/, parts[0] + '.' + parts[1])
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma);
}

function initProducto() {
  var root = document.querySelector('[data-mt-producto]');
  if (!root || root.hasAttribute('data-mt-bound')) return;
  root.setAttribute('data-mt-bound', 'true');

  var moneyFormatEl = document.querySelector('[data-mt-money-format]');
  var moneyFormat = moneyFormatEl ? moneyFormatEl.textContent.trim() : '';

  var mainImgs = root.querySelectorAll('[data-mt-galeria-img]');
  var thumbs = root.querySelectorAll('[data-mt-miniatura]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var id = thumb.getAttribute('data-mt-miniatura');
      thumbs.forEach(function (t) { t.classList.toggle('mt-activa', t === thumb); });
      mainImgs.forEach(function (img) {
        img.classList.toggle('mt-activa', img.getAttribute('data-mt-galeria-img') === id);
      });
    });
  });

  var variantsJsonEl = root.querySelector('[data-mt-variantes]');
  if (!variantsJsonEl) return;

  var variants;
  try { variants = JSON.parse(variantsJsonEl.textContent); } catch (e) { return; }

  var idInput = root.querySelector('[data-mt-variant-id]');
  var priceEl = root.querySelector('[data-mt-precio]');
  var priceBeforeEl = root.querySelector('[data-mt-precio-antes]');
  var buyBtn = root.querySelector('[data-mt-boton-comprar]');
  var buyBtnText = root.querySelector('[data-mt-boton-texto]');
  var textoAgotado = buyBtn ? (buyBtn.getAttribute('data-mt-texto-agotado') || 'Agotado') : 'Agotado';
  var textoComprar = buyBtnText ? buyBtnText.textContent.trim() : 'Añadir al carrito';
  var optionGroups = root.querySelectorAll('[data-mt-opcion]');

  function seleccionActual() {
    var seleccion = [];
    optionGroups.forEach(function (group) {
      var activo = group.querySelector('.mt-activa');
      seleccion.push(activo ? activo.getAttribute('data-mt-valor') : null);
    });
    return seleccion;
  }

  function encontrarVariante(seleccion) {
    return variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return seleccion.every(function (val, i) { return val === null || opts[i] === val; });
    });
  }

  function actualizar() {
    var seleccion = seleccionActual();
    var variante = encontrarVariante(seleccion);
    if (!variante) return;

    if (idInput) idInput.value = variante.id;
    if (priceEl) priceEl.textContent = mtFormatMoney(variante.price, moneyFormat);
    if (priceBeforeEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        priceBeforeEl.textContent = mtFormatMoney(variante.compare_at_price, moneyFormat);
        priceBeforeEl.style.display = '';
      } else {
        priceBeforeEl.style.display = 'none';
      }
    }
    if (buyBtn) {
      buyBtn.disabled = !variante.available;
      if (buyBtnText) buyBtnText.textContent = variante.available ? textoComprar : textoAgotado;
    }
  }

  optionGroups.forEach(function (group) {
    group.querySelectorAll('[data-mt-valor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('[data-mt-valor]').forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
        actualizar();
      });
    });
  });
}

function initColeccionCarrito() {
  var botones = document.querySelectorAll('[data-mt-add-to-cart]');
  if (!botones.length) return;

  var barra = document.querySelector('[data-mt-carrito-flotante]');
  var resumen = barra ? barra.querySelector('[data-mt-carrito-resumen]') : null;

  function refrescarResumen() {
    fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!barra) return;
        if (cart.item_count > 0) {
          barra.hidden = false;
          requestAnimationFrame(function () { barra.classList.add('mt-visible'); });
          if (resumen) {
            var plural = cart.item_count === 1 ? 'artículo' : 'artículos';
            resumen.textContent = cart.item_count + ' ' + plural + ' · ' + mtFormatMoneySimple(cart.total_price);
          }
        }
        actualizarBurbujaCabecera(cart.item_count);
      })
      .catch(function () {});
  }

  function actualizarBurbujaCabecera(count) {
    var burbuja = document.querySelector('.cart-count-bubble span[aria-hidden]');
    if (burbuja) burbuja.textContent = count;
    var contenedor = document.querySelector('#cart-icon-bubble');
    if (contenedor && count > 0) contenedor.querySelector('.cart-count-bubble')?.removeAttribute('hidden');
  }

  botones.forEach(function (btn) {
    if (btn.hasAttribute('data-mt-bound')) return;
    btn.setAttribute('data-mt-bound', 'true');
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.classList.contains('mt-cargando')) return;
      var variantId = btn.getAttribute('data-variant-id');
      var label = btn.querySelector('[data-mt-add-label]');
      var textoOriginal = label ? label.textContent : '';

      btn.classList.add('mt-cargando');
      if (label) label.textContent = 'Añadiendo…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          btn.classList.remove('mt-cargando');
          if (!res.ok) {
            if (label) label.textContent = 'No se pudo añadir';
            setTimeout(function () { if (label) label.textContent = textoOriginal; }, 2200);
            return;
          }
          btn.classList.add('mt-anadido');
          if (label) label.textContent = 'Añadido ✓';
          setTimeout(function () {
            btn.classList.remove('mt-anadido');
            if (label) label.textContent = textoOriginal;
          }, 1800);
          refrescarResumen();
        })
        .catch(function () {
          btn.classList.remove('mt-cargando');
          if (label) label.textContent = 'No se pudo añadir';
          setTimeout(function () { if (label) label.textContent = textoOriginal; }, 2200);
        });
    });
  });

  refrescarResumen();
}

function mtFormatMoneySimple(cents) {
  var moneyFormatEl = document.querySelector('[data-mt-money-format]');
  var format = moneyFormatEl ? moneyFormatEl.textContent.trim() : '';
  return mtFormatMoney(cents, format);
}
